export default __webpack_public_path__ + "static/media/p3.3ca9bf72.jpg";